<script setup>
const props = defineProps({
    subscriptionId: { type: Number, required: true },
    contentId: { type: Number, required: true, },
    isFree: { type: Boolean, required: true },
    isGiftCardPurchasable: { type: Boolean, required: true },
    giftCardBalance: { type: Number, default: null },
});
</script>
<template>

    <purchase-button-base
        v-if="isFree"
        :request-url="route('subscription.content.purchaseFree', [subscriptionId, contentId])"
        @success="$document.locationAssign(route('subscription.content', [subscriptionId, contentId]))"
    >
        <template #default><slot></slot></template>
    </purchase-button-base>

    <purchase-button-base
        v-else-if="isGiftCardPurchasable"
        :request-url="route('subscription.content.purchasePaid', [subscriptionId, contentId])"
        :request-data="{ payment_method: 'gift-card' }"
        @success="$document.locationAssign(route('subscription.content', [subscriptionId, contentId]))"
    >
        <template #default><slot></slot> ({{ _mft('subscription:withCoupon') }})</template>
    </purchase-button-base>

    <template v-else>
        <purchase-button-cash
            :request-url="route('subscription.content.purchasePaid', [subscriptionId, contentId])"
            :gift-card-balance="giftCardBalance"
        >
            <template #default><slot></slot></template>
        </purchase-button-cash>
    </template>
</template>
